module.exports = __webpack_public_path__ + "static/media/CardCaldasNovas3.e70147fb.jpg";